import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../api/client';
import { endpoints } from '../../../api/endpoints';
import type { PendingListResponse } from '../../../types/api';

export function useCollectionsPendingCount() {
  return useQuery<number>({
    queryKey: ['collections-pending-count'],
    queryFn: async () => {
      const res = await apiClient.get<PendingListResponse>(endpoints.pending.list, {
        params: { limit: 1 },
      });
      return res.data.pagination.total;
    },
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}
